export default __webpack_public_path__ + "static/media/QUESTIONS.61ac8b25.png";